import { ToastData } from "../ToastSystem";
import SystemRegistry from "../systemRegistry";
import Event from "./Event";

export default class EventHandler {
    static instance;

    constructor() {
        this.typeToHeader = {}
        this.typeToHeader[Event.INFO] = "Hinweis"
        this.typeToHeader[Event.ERROR] = "Fehler"
    }

    static getInstance(){
        if(!this.instance){
            this.instance = new EventHandler()
        }
        return this.instance
    }

    static gI(){
       return this.getInstance()
    }

    triggerEvent(event){
        if(event.triggerToast){
            SystemRegistry.gI().toastContainer.addToast(new ToastData(event.type, this.typeToHeader[event.type], event.message))
        }
    }
}